import React, { useId } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input: React.FC<InputProps> = ({ label, error, className = '', id, 'aria-describedby': describedBy, ...props }) => {
  const generatedId = useId();
  const inputId = id || `intrlock-input-${generatedId.replace(/:/g, '')}`;
  const errorId = `${inputId}-error`;
  const ariaDescribedBy = [describedBy, error ? errorId : null].filter(Boolean).join(' ') || undefined;

  return (
    <div className="mb-4">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <input
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={ariaDescribedBy}
        className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 transition-colors ${error ? 'border-red-300 bg-red-50' : 'border-gray-300'} ${className}`}
        {...props}
      />
      {error && <p id={errorId} role="alert" className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  children: React.ReactNode;
}

export const Select: React.FC<SelectProps> = ({ label, error, children, className = '', id, 'aria-describedby': describedBy, ...props }) => {
  const generatedId = useId();
  const selectId = id || `intrlock-select-${generatedId.replace(/:/g, '')}`;
  const errorId = `${selectId}-error`;
  const ariaDescribedBy = [describedBy, error ? errorId : null].filter(Boolean).join(' ') || undefined;

  return (
    <div className="mb-4">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <select
        id={selectId}
        aria-invalid={error ? true : undefined}
        aria-describedby={ariaDescribedBy}
        className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-brand-500 ${error ? 'border-red-300 bg-red-50' : 'border-gray-300'} ${className}`}
        {...props}
      >
        {children}
      </select>
      {error && <p id={errorId} role="alert" className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};
